import {Component, Input, OnInit} from '@angular/core';

@Component({
  selector: 'app-wrapper',
  templateUrl: './wrapper.component.html'  
})
export class WrapperComponent implements OnInit{
	@Input() wrapperCssClass: string;
    
    constructor() {
    }

    ngOnInit() {
    
    }

}



// WEBPACK FOOTER //
// ./src/bpa_client_src/app/components/wrapper/wrapper.component.ts